import { expose } from 'comlink';
import { collection, getDocs, getFirestore, query, where } from 'firebase/firestore';
import { AssetTypeCfg, IssueCfg } from '../../issue/issue.dto';
import { AbstractWarehouseSyncStepWorker } from './abstract-warehouse-worker.utils';
import { WarehouseSyncStepTaskContext } from '../executors';
import type { ProgressCallback } from '../executors';
import { DocumentData } from '@angular/fire/firestore';
import { ASSET_CFG_COLLECTION, ASSET_TYPES_STORE, ISSUE_CFG_COLLECTION, ISSUE_CFGS_STORE, logger } from '@damofire/data-commons';

export class WarehouseConfigsStepsWorker extends AbstractWarehouseSyncStepWorker {
  constructor() {
    super(null, 'CONFIGS');
  }

  protected async download(ctx: WarehouseSyncStepTaskContext, onProgress?: ProgressCallback): Promise<void> {
    logger.debug('WarehouseConfigsStepsWorker::download', { division: ctx.division, category: 'sync' });

    const issueCfg = await this.getIssuesCfg();
    await this.idbService.update(ISSUE_CFGS_STORE, issueCfg);

    const assetTypeCfg = await this.getAssetsCfg();
    await this.idbService.updateAll(ASSET_TYPES_STORE, assetTypeCfg);

    if (!this.shouldStopTask) {
      const total = 1 + assetTypeCfg.length;
      onProgress?.(100, { processed: total, expected: total });
    }
  }

  private async getIssuesCfg(): Promise<IssueCfg> {
    logger.debug('Fetching issue cfg', { category: 'sync' });
    const defaultCfg = await getDocs<IssueCfg, DocumentData>(query(collection(getFirestore(), ISSUE_CFG_COLLECTION), where('default', '==', true)));
    const docChange = defaultCfg.docs[0];
    return { ...docChange.data(), organizationId: 'default' };
  }

  private async getAssetsCfg(): Promise<AssetTypeCfg[]> {
    logger.debug('Fetching asset types', { category: 'sync' });
    const cfg = await getDocs<AssetTypeCfg, DocumentData>(query(collection(getFirestore(), ASSET_CFG_COLLECTION)));
    return cfg.docs.map((doc) => doc.data());
  }
}

expose(WarehouseConfigsStepsWorker);
